module.exports = __webpack_public_path__ + "static/media/AwsDoc5.970d348f.png";